module.exports = __webpack_public_path__ + "static/media/wAhyIChODzsoKIOBHcBk.356efdc3.svg";